export const locale = {
  required_fields: 'Required field',
};
